@if (parseRequestsLoading()) {
  <ui-skeleton class="block rounded-md h-10 w-full sm:w-50" />
} @else if (openParseRequests().length > 1) {
  <ui-button
    [mode]="mode()"
    expand="full"
    [loading]="isLoading()"
    uiPopover
    [anchor]="uiPopover"
    popoverEvent="click"
    class="block"
    [disabled]="disabled() || isLoading()"
    disableInDemoMode
  >
    <ng-icon name="heroDocumentPlus" slot="start" size="20" class="!block" />
    {{ 'cockpit.supplierContracts.page.addContractsButton' | transloco }}
  </ui-button>
  <ui-popover popover #uiPopover>
    <ui-menu-list>
      @for (openParseRequest of openParseRequests(); track openParseRequest.id; let i = $index) {
        <ui-menu-list-item
          (click)="uiPopover.hide()"
          [routerLink]="[
            '/organizations',
            organizationId(),
            'parse-requests',
            openParseRequest.id,
            'create',
          ]"
          [relativeTo]="activatedRoute"
        >
          @if (openParseRequest.data?.metadata?.createdAt; as createdAt) {
            {{
              'cockpit.parseRequests.button.requestFromDateContinue'
                | transloco
                  : {
                      date: (createdAt | date: 'dd.MM.'),
                      time: (createdAt | date: 'HH:mm'),
                    }
            }}
          } @else {
            {{ 'cockpit.parseRequests.button.requestNumber' | transloco: { number: i + 1 } }}
          }
        </ui-menu-list-item>
      }
    </ui-menu-list>
  </ui-popover>
} @else {
  <ui-button
    [mode]="mode()"
    expand="full"
    (click)="onClickCreateParseRequest()"
    [loading]="isLoading()"
    class="block"
    [disabled]="disabled()"
    disableInDemoMode
  >
    <ng-icon name="heroDocumentPlus" slot="start" size="20" class="!block" />
    {{ 'cockpit.supplierContracts.page.addContractsButton' | transloco }}
  </ui-button>
}
